import { useAssetTransformationTaskEvent } from '~/components/EditMode/hooks/useAssetTransformationTaskEvent';

export const EditModeTaskEventListener = () => {
  useAssetTransformationTaskEvent();
  return null;
};
